module.exports = {
      id: "comm-cinema-usage",
      viewBox: "0 0 415.94 49.818",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-cinema",
      toString: function () {
        return this.url;
      }
    }